import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { ProjectEditCustomPartOfferPage } from '@/areas/offers/CustomPartOfferForm/pages/ProjectEditCustomPartOfferPage';
import { sourcingEditModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/next/projects/$projectId/sourcing/offers/custom-part/$offerId/edit',
)({
    staticData: {
        access: { permissions: ['view:sourcing'], modulePermissions: sourcingEditModulePermissions },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <ProjectEditCustomPartOfferPage projectId={pathParams.projectId} offerId={pathParams.offerId} />;
}
